import React from 'react';
import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';

// COMPONENTES
import MyAutoComplete from '../../../components/inputs/MyAutoComplete';
import MyTextInput from '../../../components/inputs/MyTextInput';

const AgregarIncidencia = ({ open, onClose, refresh }) => {

    const catalogoSeverity = [

        {value: 'LOW', label: 'LOW'},
        {value: 'MEDIUM', label: 'MEDIUM'},
        {value: 'HIGH', label: 'HIGH'},

    ]

    return (

        <Dialog
            open={open}
            onClose={onClose}
        >

            {/* HEADER */}

            <DialogTitle sx={{ textAlign: 'center' }}>
                Agregar Motivo
            </DialogTitle>

            {/* BODY */}

            <DialogContent>

                <Formik
                    initialValues={{
                        reason: '',
                        severity: '',
                        is_active: 1,
                    }}
                    enableReinitialize={true}
                    validationSchema={Yup.object({
                        reason: Yup.string().required('Ingresa una descripcion'),
                        severity: Yup.string().required('Selecciona una Opcion'),
                    })}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {

                        try {

                            const response = await myApi.post('/reasons/create', values);

                            if(response.data){

                                setSubmitting(false);
                                resetForm();
                                onClose();
                                refresh();

                                Swal.fire({
                                    icon: 'success',
                                    title: 'Motivo Agregado',
                                });

                            }

                        } catch(e) {

                            console.log(e);
                            setSubmitting(false);
                            resetForm();

                        }   

                    }}
                >
                {({ handleSubmit }) => (

                    <Form>

                        <Grid container spacing={2} marginTop={1}>

                            {/* MOTIVO DE RETRASO */}

                            <Grid size={12}>

                                <MyTextInput
                                    name="reason"
                                    label="Descripcion"
                                />

                            </Grid>

                            {/* SEVERITY */}

                            <Grid size={12}>

                                <MyAutoComplete
                                    name="severity"
                                    label="Severity"
                                    options={catalogoSeverity}
                                />

                            </Grid>

                            {/* FOOTER */}

                            <Grid size={12}>

                                <DialogActions
                                    sx={{ justifyContent: 'space-between' }}
                                >

                                    <Button 
                                        type="submit" 
                                        variant="contained" 
                                        color="primary"
                                        onClick={handleSubmit}
                                    >
                                        Guardar
                                    </Button>

                                    <Button onClick={onClose}>Cancelar</Button>

                                </DialogActions>

                            </Grid>

                        </Grid>

                    </Form>

                )}
                </Formik>

            </DialogContent>

        </Dialog>

    )

}

export default AgregarIncidencia